module.exports = "\n<div class=\"row\">\n  <div class=\"col-12\">\n    <div class=\"static-page-wrap\" [innerHTML]=\"description\"></div>\n  </div>\n</div>\n\n"